import { ReduxActionType } from 'types';

type ActionTypes = {
  FETCH_ENQUIRY_BYID: ReduxActionType;
  FETCH_ENQUIRY_BYID_SUCCESS: ReduxActionType;
  FETCH_ENQUIRY_BYID_FAILURE: ReduxActionType;

  FETCH_ENQUIRY_ACT_DESIGN: ReduxActionType;
  FETCH_ENQUIRY_ACT_EXCAVATE: ReduxActionType;
  RESET_LODGE_ENQUIRY_STATE: ReduxActionType;

  FETCH_ENQUIRY_HISTORY: ReduxActionType;
  FETCH_ENQUIRY_HISTORY_SUCCESS: ReduxActionType;
  FETCH_ENQUIRY_HISTORY_FAILURE: ReduxActionType;

  SET_ENQUIRY_SEARCH_FILTER: ReduxActionType;

  UPDATE_ENQUIRY_BYID: ReduxActionType;
  UPDATE_ENQUIRY_BYID_SUCCESS: ReduxActionType;
  UPDATE_ENQUIRY_BYID_FAILURE: ReduxActionType;

  CONNECT_WEBSOCKET_FOR_ENQUIRY: ReduxActionType;
  CONNECT_WEBSOCKET_FOR_DOWNLOAD_FILE: ReduxActionType;
  UPDATE_ENQUIRY_REFERRAL: ReduxActionType;

  RESET_ENQUIRY_SHAPE: ReduxActionType;
  SET_FORWARD_ENQUIRY_EXTERNAL_ID: ReduxActionType;
  SET_FORWARD_ENQUIRY_IS_LIST_VIEW: ReduxActionType;
  SET_FORWARD_ENQUIRY_DATE_RANGE_TEXT: ReduxActionType;
  CLEAR_ALL_ENQUIRY_STATE: ReduxActionType;

  CLEAR_ENQUIRIES: ReduxActionType;

  DOWNLOAD_ENQUIRY_COMBINED_FILE_START: ReduxActionType;
  DOWNLOAD_ENQUIRY_COMBINED_FILE_SUCCESS: ReduxActionType;
  DOWNLOAD_ENQUIRY_COMBINED_FILE_FAILURE: ReduxActionType;
  RESET_DOWNLOAD_ENQUIRY_COMBINED_FILE: ReduxActionType;

  GET_ATTACHMENT_PREVIEW_URL_START: ReduxActionType;
  GET_ATTACHMENT_PREVIEW_URL_SUCCESS: ReduxActionType;
  GET_ATTACHMENT_PREVIEW_URL_FAILURE: ReduxActionType;
  RESET_ATTACHMENT_PREVIEW_URL: ReduxActionType;
  GET_ATTACHMENT_DOWNLOAD_URL_START: ReduxActionType;
  GET_ATTACHMENT_DOWNLOAD_URL_SUCCESS: ReduxActionType;
  GET_ATTACHMENT_DOWNLOAD_URL_FAILURE: ReduxActionType;
  RESET_ATTACHMENT_DOWNLOAD_URL: ReduxActionType;

  GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_START: ReduxActionType;
  GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_SUCCESS: ReduxActionType;
  GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_FAILURE: ReduxActionType;
  RESET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL: ReduxActionType;

  GET_DOWNLOAD_ADVANCED_OPTIONS_START: ReduxActionType;
  GET_DOWNLOAD_ADVANCED_OPTIONS_SUCCESS: ReduxActionType;
  GET_DOWNLOAD_ADVANCED_OPTIONS_FAILURE: ReduxActionType;
  RESET_DOWNLOAD_ADVANCED_OPTIONS: ReduxActionType;
};

export const EnquiresActionTypes: ActionTypes = {
  FETCH_ENQUIRY_BYID: '@@FETCH_ENQUIRY_BYID',
  FETCH_ENQUIRY_BYID_SUCCESS: '@@FETCH_ENQUIRY_BYID_SUCCESS',
  FETCH_ENQUIRY_BYID_FAILURE: '@@FETCH_ENQUIRY_BYID_FAILURE',

  FETCH_ENQUIRY_ACT_DESIGN: '@@FETCH_ENQUIRY_ACT_DESIGN',
  FETCH_ENQUIRY_ACT_EXCAVATE: '@@FETCH_ENQUIRY_ACT_EXCAVATE',
  RESET_LODGE_ENQUIRY_STATE: '@@RESET_LODGE_ENQUIRY_STATE',
  FETCH_ENQUIRY_HISTORY: '@@FETCH_ENQUIRY_HISTORY',
  FETCH_ENQUIRY_HISTORY_SUCCESS: '@@FETCH_ENQUIRY_HISTORY_SUCCESS',
  FETCH_ENQUIRY_HISTORY_FAILURE: '@@FETCH_ENQUIRY_HISTORY_FAILURE',

  SET_ENQUIRY_SEARCH_FILTER: '@@SET_ENQUIRY_SEARCH_FILTER',

  UPDATE_ENQUIRY_BYID: '@@UPDATE_ENQUIRY_BYID',
  UPDATE_ENQUIRY_BYID_SUCCESS: '@@UPDATE_ENQUIRY_BYID_SUCCESS',
  UPDATE_ENQUIRY_BYID_FAILURE: '@@UPDATE_ENQUIRY_BYID_FAILURE',

  CONNECT_WEBSOCKET_FOR_ENQUIRY: '@@CONNECT_WEBSOCKET_FOR_ENQUIRY',
  CONNECT_WEBSOCKET_FOR_DOWNLOAD_FILE: '@@CONNECT_WEBSOCKET_FOR_DOWNLOAD_FILE',
  UPDATE_ENQUIRY_REFERRAL: '@@UPDATE_ENQUIRY_REFERRAL',

  RESET_ENQUIRY_SHAPE: '@@RESET_ENQUIRY_SHAPE',
  SET_FORWARD_ENQUIRY_EXTERNAL_ID: '@@SET_FORWARD_ENQUIRY_EXTERNAL_ID',
  SET_FORWARD_ENQUIRY_IS_LIST_VIEW: '@@SET_FORWARD_ENQUIRY_IS_LIST_VIEW',
  SET_FORWARD_ENQUIRY_DATE_RANGE_TEXT: '@@SET_FORWARD_ENQUIRY_DATE_RANGE_TEXT',
  CLEAR_ALL_ENQUIRY_STATE: '@@CLEAR_ALL_ENQUIRY_STATE',
  CLEAR_ENQUIRIES: '@@CLEAR_ENQUIRIES',

  DOWNLOAD_ENQUIRY_COMBINED_FILE_START:
    '@@DOWNLOAD_ENQUIRY_COMBINED_FILE_START',
  DOWNLOAD_ENQUIRY_COMBINED_FILE_SUCCESS:
    '@@DOWNLOAD_ENQUIRY_COMBINED_FILE_SUCCESS',
  DOWNLOAD_ENQUIRY_COMBINED_FILE_FAILURE:
    '@@DOWNLOAD_ENQUIRY_COMBINED_FILE_FAILURE',
  RESET_DOWNLOAD_ENQUIRY_COMBINED_FILE:
    '@@RESET_DOWNLOAD_ENQUIRY_COMBINED_FILE',

  GET_ATTACHMENT_PREVIEW_URL_START: '@@GET_ATTACHMENT_PREVIEW_URL_START',
  GET_ATTACHMENT_PREVIEW_URL_SUCCESS: '@@GET_ATTACHMENT_PREVIEW_URL_SUCCESS',
  GET_ATTACHMENT_PREVIEW_URL_FAILURE: '@@GET_ATTACHMENT_PREVIEW_URL_FAILURE',
  RESET_ATTACHMENT_PREVIEW_URL: '@@RESET_ATTACHMENT_PREVIEW_URL',
  GET_ATTACHMENT_DOWNLOAD_URL_START: '@@GET_ATTACHMENT_DOWNLOAD_URL_START',
  GET_ATTACHMENT_DOWNLOAD_URL_SUCCESS: '@@GET_ATTACHMENT_DOWNLOAD_URL_SUCCESS',
  GET_ATTACHMENT_DOWNLOAD_URL_FAILURE: '@@GET_ATTACHMENT_DOWNLOAD_URL_FAILURE',
  RESET_ATTACHMENT_DOWNLOAD_URL: '@@RESET_ATTACHMENT_DOWNLOAD_URL',

  GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_START:
    '@@GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_START',
  GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_SUCCESS:
    '@@GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_SUCCESS',
  GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_FAILURE:
    '@@GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_FAILURE',
  RESET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL:
    '@@RESET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL',

  GET_DOWNLOAD_ADVANCED_OPTIONS_START: '@@GET_DOWNLOAD_ADVANCED_OPTIONS_START',
  GET_DOWNLOAD_ADVANCED_OPTIONS_SUCCESS:
    '@@GET_DOWNLOAD_ADVANCED_OPTIONS_SUCCESS',
  GET_DOWNLOAD_ADVANCED_OPTIONS_FAILURE:
    '@@GET_DOWNLOAD_ADVANCED_OPTIONS_FAILURE',
  RESET_DOWNLOAD_ADVANCED_OPTIONS: '@@RESET_DOWNLOAD_ADVANCED_OPTIONS'
};

export interface EnquirySearchFilters {
  createdAfter: string;
  createdBefore: string;
  digStartAfter: string;
  digStartBefore: string;
  status: string[];
  userReference: string;
  address: string;
  isAutoRenewPending: boolean;
  isSandboxTest: boolean;
  tenantId?: string;
}

interface Data {
  lodgeEnquiry?: {
    enquiries?: Object;
    designAct?: Object;
    excavationAct?: Object;
  };
  enquiry?: any;
  enquiries?: any;
  filters?: EnquirySearchFilters;
  forwardEnquiryExternalId?: number;
  forwardIsListView?: boolean;
  forwardDateRangeText?: string;
}
export interface EnquiryState {
  loading?: boolean;
  enquiryLoader?: boolean;
  updatingEnquiry?: boolean;
  loader?: boolean;
  error?: string;
  paginationInfo?: Object;
  data: Data;
  downloadingCombinedZip?: number | string;
  downloadingCombinedPdf?: number | string;
  attachmentPreviewUrl?: string;
  isLoadingAttachmentPreviewUrl?: boolean;
  attachmentDownloadUrl?: string;
  isLoadingAttachmentDownloadUrl?: boolean;
  zipDownloadStatus?: boolean;
  pdfDownloadStatus?: boolean;
  isLoadingEnquiryConfirmationPDFDownloadUrl?: boolean;
  enquiryConfirmationPDFDownloadUrl?: string;
  downloadAdvancedOptions?: DownloadAdvancedOptions[];
  isLoadingDownloadAdvancedOptions?: boolean;
}

export interface DownloadEnquiryCombinedFilePayload {
  enquiryId: number;
  fileType: 'zip' | 'pdf';
  shareId?: string;
  isFromSwxLocate?: boolean;
  includeLookUpAndLive?: boolean;
  lualMapZoomLevel?: number;
  advancedOptions?: any;
}

export interface DownloadAdvancedOptions {
  externalId: string;
  isCompleted: boolean;
  organisationName: string;
  attachments: DownloadAdvancedOptionsFile[];
}

export interface DownloadAdvancedOptionsFile {
  responseId: number;
  id: number | string;
  name: string;
  extension?: string;
  type: 'attachment' | 'response' | 'mail' | 'divider';
}
